// §2 display-state chip for nsofar consult SRs (docs/33). This chip — not the
// coarse HCM SR status — is the coordinator-facing lifecycle signal.

import type { JSX } from "react";
import { CONSULT_DISPLAY, type ConsultStatus } from "@hcm/core";

const TONE: Record<ConsultStatus, string> = {
  matching:         "bg-amber-100 text-amber-800",
  options_sent:     "bg-blue-100 text-blue-800",
  payment_pending:  "bg-orange-100 text-orange-800",
  selected:         "bg-purple-100 text-purple-800",
  confirmed:        "bg-green-100 text-green-800",
  needs_reschedule: "bg-red-100 text-red-800",
  completed:        "bg-slate-100 text-slate-600",
  cancelled:        "bg-slate-100 text-slate-500",
};

export function ConsultStateBadge({ status }: { status?: string | null }): JSX.Element {
  const known = status && status in CONSULT_DISPLAY ? (status as ConsultStatus) : null;
  if (!known) {
    return <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-500">—</span>;
  }
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${TONE[known]}`}>
      {CONSULT_DISPLAY[known]}
    </span>
  );
}
